// Action types
export const SET_SNACKBAR = " SET_SNACKBAR";

// Create Redux action creators that return an action
export const setSnackbar = (
  snackbarOpen,
  snackbarType = "success",
  snackbarMessage = "",
  snackbarNavPath = "",
  snackbarNavParams = {},
  snackbarAutoHideDuration = 10000
) => ({
  type: SET_SNACKBAR,
  snackbarOpen,
  snackbarType,
  snackbarMessage,
  snackbarNavPath,
  snackbarNavParams,
  snackbarAutoHideDuration,
});
